// The products half of the dealer's `resolveScrollMode.ts`: which routes own their whole
// viewport. The embed has no app shell to set a scroll mode on, so only the product shell's
// fill mode reads this.

import { pathIsUnder } from '@hopdrive/feature-portal-products';
import { movesTabPath } from '@features/products/productRoutes';

/** The full-bleed surfaces — a map/ops surface managing its own layout, never merely a tall page. */
export const FULL_BLEED_ROUTES: readonly string[] = ['/mobile-service/map', '/parts-delivery/live', movesTabPath('team')];

/** Whether a path is one of the full-bleed surfaces or a subpath of one (segment-boundary match,
 *  so '/parts-delivery/live' never matches a sibling like '/parts-delivery/livewire'). */
export function isFullBleedPath(pathname: string): boolean {
  return FULL_BLEED_ROUTES.some(route => pathIsUnder(route, pathname));
}
